import { FIELD_GRID_CLASS } from 'components/GridItemList';
import { createContext, useContext } from 'react';
import { cn } from 'utils/cn';

export const InSectionEditFormContext = createContext(false);

/**
 * True where a form's fields are laid on {@link FIELDS_CLASS}: a shared input there may draw the new design's
 * field instead of classic's.
 */
export const useInSectionEditForm = () => useContext(InSectionEditFormContext);

// The read view's grid, on the section's own width, capped at two columns: a text area, an alert or a group of
// fields a form section wraps in its own block takes the whole row, and a third column would sit empty beside most
// of them. A field is one cell. Labels are the read view's 12px.
export const FIELDS_CLASS = cn(
    FIELD_GRID_CLASS,
    'gap-x-5 gap-y-3 *:m-0! @2xl:grid-cols-2',
    '[&>*:not(.form-field)]:col-span-full [&>.form-field:has(textarea)]:col-span-full',
    '[&_[data-slot=field-label]]:text-foreground-secondary [&_[data-slot=field-label]]:text-xs [&_[data-slot=field-label]]:font-medium'
);
